import type { ResumeData } from "@stylingcv/schema";
import { resumeDataSchema } from "@stylingcv/schema";
import type { Json } from "@stylingcv/utils";
import type { Schema } from "zod";

import type { Parser } from "../interfaces/parser";

export class ReactiveResumeParser implements Parser<Json, ResumeData> {
  schema: Schema;

  constructor() {
    this.schema = resumeDataSchema;
  }

  readFile(file: File): Promise<Json> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      reader.onload = () => {
        try {
          const result = JSON.parse(reader.result as string) as Json;
          resolve(result);
        } catch {
          reject(new Error("Failed to parse JSON"));
        }
      };

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      reader.onerror = () => {
        reject(new Error("Failed to read the file"));
      };

      // eslint-disable-next-line unicorn/prefer-blob-reading-methods
      reader.readAsText(file);
    });
  }

  validate(data: Json) {
    const result = resumeDataSchema.safeParse(data);
    if (!result.success) {
      console.error(
        "[ReactiveResumeParser] Validation errors:",
        result.error.issues.map((i) => ({
          path: i.path.join("."),
          message: i.message,
          code: i.code,
        })),
      );
      throw result.error;
    }
    return result.data;
  }

  convert(data: ResumeData) {
    return data;
  }
}
